import { Component, OnInit } from '@angular/core';
import { FocusConfig, ICON_TYPE } from '@spartacus/storefront';
import { Subscription, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GenCheckoutService } from 'src/app/generac/services/checkout.service';
import { GenLaunchDialogService } from 'src/app/generac/services/launch-dialog.service';

@Component({
  selector: 'gen-split-payment-dialog',
  templateUrl: './split-payment-dialog.component.html',
  standalone: false
})
export class GenSplitPaymentDialogComponent implements OnInit {
  focusConfig: FocusConfig = {
    trap: true,
    block: true,
    autofocus: 'button',
    focusOnEscape: true,
  };

  iconTypes = ICON_TYPE;
  compatibleProducts: string[];
  nonCompatibleProducts: string[];
  cartId: string;
  userId: string;
  loading: boolean = false;

  protected subscription = new Subscription();

  constructor(
    protected launchDialogService: GenLaunchDialogService,
    protected checkoutService: GenCheckoutService,
  ) { }

  ngOnInit(): void {
    this.subscription.add(
      this.launchDialogService.data$.subscribe(
        (dialogData: any) => {
          this.compatibleProducts = dialogData?.checkPaymentResponse.compatibleProducts;
          this.nonCompatibleProducts = dialogData?.checkPaymentResponse.nonCompatibleProducts;
          this.cartId = dialogData?.cartId;
          this.userId = dialogData?.userId;
        }
      )
    );
  }

  continue(): void {
    this.loading = true;
    this.checkoutService.sanitizeCartForWellsFargo(this.cartId, this.userId).pipe(
      catchError((error) => {
        this.loading = false;
        return throwError(() => error);
      }),
    ).subscribe(() => {
      this.loading = false;
      this.dismiss('splitPayment');
    });
  }

  dismiss(reason?: any): void {
    this.launchDialogService.closeDialog(reason, 'CHECKOUT_SPLIT_PAYMENT_DIALOG');
  }
}
